/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'automation-menu.empty-state.image.alt': "Icône de liste d'automatisation vide",
  'automation-menu.empty-state.learn-more.link': 'En savoir plus sur le déclencheur manuel',
  'automation-menu.modal.empty.automations.admin.description':
    "Utilisez le déclencheur manuel pour remplir un menu de sélections que n'importe qui, ou les personnes de votre choix, peuvent appliquer sous forme d'automatisations en un clic.",
  'automation-menu.modal.empty.automations.user.description':
    "Les administrateurs n'ont pas encore configuré d'automatisations déclenchées manuellement.",
  'automation-menu.modal.error.description': "Le chargement prend un certain temps. Essayez d'actualiser la page.",
  'automation-menu.modal.error.image.alt': "Icône d'erreur",
  'automation-menu.modal.footer.automate-button': 'Automatiser',
  'automation-menu.modal.footer.cancel-button': 'Annuler',
  'automation-menu.modal.footer.get-started-button': 'Créer une automatisation',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': "Icône d'en-tête de fenêtre modale d'automatisation",
  'automation-menu.success-state.message': "Votre règle d'automatisation est en cours d'exécution",
  'fabric.linking.access_exists_description': "Demandez l'accès à {hostname} pour afficher ce contenu.",
  'fabric.linking.actions': 'Actions',
  'fabric.linking.add_account': 'Ajouter un compte',
  'fabric.linking.ai_summarize': 'Résumer',
  'fabric.linking.ai_summarized': 'Résumé par Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Résumé par AI',
  'fabric.linking.ai_summarized_info': 'La qualité des informations peut varier. <a>En savoir plus</a>',
  'fabric.linking.ai_summarized_info_short': 'La qualité du contenu est susceptible de varier',
  'fabric.linking.ai_summarizing': "Atlassian Intelligence est à l'œuvre…",
  'fabric.linking.ai_summary_action': 'Résumez avec Atlassian Intelligence',
  'fabric.linking.ai_summary_action_description': 'Résumez le contenu de ce lien grâce à Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    "Impossible d'afficher les résultats de ce résumé, car cela va à l'encontre de la <a>politique d'utilisation acceptable d'Atlassian</a>.",
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence ne peut pas vous générer de résumé pour le moment, car il y a trop de contenu à résumer.',
  'fabric.linking.ai_summary_error_generic':
    "Atlassian Intelligence (AI) ne répond pas. Réessayez plus tard ou <a>vérifiez l'état d'AI</a>.",
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    "Atlassian Intelligence n'a pas été en mesure de traiter votre demande, car votre contenu comprend des liens vers du contenu soumis à des restrictions HIPAA.",
  'fabric.linking.assigned_to': 'Assigné à {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    "Appliquez une automatisation à <b>{name}</b>.{br}Les sélections disponibles sont contrôlées par Confluence et les administrateurs d'espace.",
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automatisations de page',
  'fabric.linking.automation-action.icon.label': "Icône d'automatisation",
  'fabric.linking.automation-action.title': "Afficher les règles d'automatisation",
  'fabric.linking.automation-action.tooltip': "Sélectionner une règle d'automatisation à exécuter",
  'fabric.linking.beta': 'Bêta',
  'fabric.linking.cancel': 'Annuler',
  'fabric.linking.cannot_connect': 'Connexion impossible, réessayez',
  'fabric.linking.cannot_find_link': 'Le lien est introuvable',
  'fabric.linking.check_this_link': 'Vérifiez ce lien',
  'fabric.linking.click_to_join': 'Rejoindre {context}',
  'fabric.linking.click_to_join_description':
    "Vous avez reçu l'approbation, vous pouvez donc rejoindre {context} immédiatement.",
  'fabric.linking.close': 'Fermer',
  'fabric.linking.connect_account_description':
    'Nous ouvrirons une nouvelle page pour vous aider à vous connecter à votre compte {name}',
  'fabric.linking.connect_link_account': "Connecter à l'aperçu",
  'fabric.linking.connect_link_account_card_view': 'Connecter',
  'fabric.linking.connect_link_account_card_view_description':
    'Pour afficher un aperçu de ce lien, connectez votre compte {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Connectez votre compte {context}',
  'fabric.linking.connect_to': 'Se connecter à {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Se connecter à {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Connectez votre compte {context} pour collaborer sur le travail dans les produits Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Connectez votre compte pour collaborer sur le travail dans les produits Atlassian.',
  'fabric.linking.continue': 'Continuer',
  'fabric.linking.copied_summary_action_description': 'Résumé copié dans le presse-papiers',
  'fabric.linking.copied_url_to_clipboard': 'Copiée !',
  'fabric.linking.copy_summary_action': 'Copier le résumé',
  'fabric.linking.copy_summary_action_description': 'Copiez le résumé',
  'fabric.linking.copy_url_to_clipboard': 'Copier le lien',
  'fabric.linking.couldnt_load_link': 'Impossible de charger ce lien pour une raison inconnue.',
  'fabric.linking.create_on_absolute': 'Créé : {context}',
  'fabric.linking.create_on_relative': 'Créé : {context}',
  'fabric.linking.created_by': 'Création par : {context}',
  'fabric.linking.delete': 'Supprimer',
  'fabric.linking.direct_access': 'Rejoindre sans plus attendre',
  'fabric.linking.direct_access_description':
    "Votre équipe utilise {product} pour collaborer, et vous pouvez commencer à l'utiliser tout de suite !",
  'fabric.linking.direct_access_title': 'Rejoignez {product} pour voir ce contenu',
  'fabric.linking.download': 'Télécharger',
  'fabric.linking.download_description': 'Téléchargez ce fichier sur votre espace de stockage local',
  'fabric.linking.download_file': 'Télécharger le fichier',
  'fabric.linking.edit': 'Modifier',
  'fabric.linking.follow': 'Suivre',
  'fabric.linking.follow_goal': "Suivre l'objectif",
  'fabric.linking.follow_goal_description': 'Suivez cet objectif pour obtenir des notifications sur les mises à jour',
  'fabric.linking.follow_goal_error':
    "Nous avons rencontré une erreur lors de la tentative de suivi de l'objectif. Vérifiez votre connexion ou actualisez la page, puis réessayez.",
  'fabric.linking.follow_project': 'Suivre le projet',
  'fabric.linking.follow_project-galaxia': "Suivre l'espace",
  'fabric.linking.follow_project_description': 'Suivez ce projet pour obtenir des notifications à son sujet',
  'fabric.linking.follow_project_description-galaxia': 'Suivez cet espace pour obtenir des notifications à son sujet',
  'fabric.linking.follow_project_error':
    'Nous avons rencontré une erreur lors de la tentative de suivi du projet. Vérifiez votre connexion ou actualisez la page, puis réessayez.',
  'fabric.linking.follow_project_error-galaxia':
    "Nous avons rencontré une erreur lors de la tentative de suivi de l'espace. Vérifiez votre connexion ou actualisez la page, puis réessayez.",
  'fabric.linking.forbidden_access': "Vous n'avez pas accès à cette ressource",
  'fabric.linking.forbidden_description': "Contactez votre administrateur pour demander l'accès à {hostname}.",
  'fabric.linking.forbidden_title': "Vous n'avez pas accès à ce contenu",
  'fabric.linking.generic_error_message': "Une erreur s'est produite",
  'fabric.linking.go_back': 'Retour',
  'fabric.linking.invalid_permissions': 'Contenu restreint',
  'fabric.linking.invalid_permissions_description':
    "Vous devrez demander l'accès ou essayer un autre compte pour afficher cet aperçu.",
  'fabric.linking.join_to_view': 'Rejoignez {context} pour consulter ce ticket',
  'fabric.linking.join_to_view-issue-term-refresh': 'Rejoignez {context} pour consulter ce ticket',
  'fabric.linking.learn_more_about_connecting_account':
    'En savoir plus sur la connexion de votre compte aux produits Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'En savoir plus sur les liens intelligents.',
  'fabric.linking.link_safety_warning_message':
    'Le lien {unsafeLinkText} essaie de vous rediriger vers un autre site, <a>actual link here</a>',
  'fabric.linking.loading': 'Chargement en cours…',
  'fabric.linking.modified_on_absolute': 'Mise à jour : {context}',
  'fabric.linking.modified_on_relative': 'Mise à jour : {context}',
  'fabric.linking.more_actions': "Plus d'actions",
  'fabric.linking.no_access_title': 'Rejoignez {product} pour voir ce contenu',
  'fabric.linking.not_found_description': "La page n'existe pas ou elle a peut-être changé après l'ajout de ce lien.",
  'fabric.linking.not_found_title': "Impossible d'afficher cette page {product}",
  'fabric.linking.open_issue_in_jira': 'Ouvrir le ticket dans Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Ouvrir le ticket dans Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Ouvrir le lien dans un nouvel onglet',
  'fabric.linking.owned_by': 'Propriétaire : {context}',
  'fabric.linking.owned_by_override': 'Par {context}',
  'fabric.linking.pending_request': "Votre demande d'accès est en attente",
  'fabric.linking.preview_close': "Fermer l'aperçu",
  'fabric.linking.preview_description': 'Ouvrez un aperçu en plein écran de ce lien',
  'fabric.linking.preview_improved': "Ouvrir l'aperçu",
  'fabric.linking.preview_max_size': 'Afficher le mode Plein écran',
  'fabric.linking.preview_min_size': 'Fermer le mode Plein écran',
  'fabric.linking.preview_modal': "Ouvrir la fenêtre modale d'aperçu",
  'fabric.linking.preview_panel': "Ouvrir le panneau d'aperçu",
  'fabric.linking.priority_blocker': 'Bloqueur',
  'fabric.linking.priority_critical': 'Critique',
  'fabric.linking.priority_high': 'Élevée',
  'fabric.linking.priority_highest': 'Maximale',
  'fabric.linking.priority_low': 'Faible',
  'fabric.linking.priority_lowest': 'Minimale',
  'fabric.linking.priority_major': 'Majeure',
  'fabric.linking.priority_medium': 'Moyenne',
  'fabric.linking.priority_minor': 'Mineure',
  'fabric.linking.priority_trivial': 'Superficielle',
  'fabric.linking.priority_undefined': 'Non définie',
  'fabric.linking.read_time': '{context} min de lecture',
  'fabric.linking.related': 'Associé',
  'fabric.linking.related_links_found_in': 'Trouvées dans',
  'fabric.linking.related_links_includes_links_to': 'Inclut des liens vers',
  'fabric.linking.related_links_modal_error_description':
    'Vérifiez votre connexion ou actualisez la page, puis réessayez',
  'fabric.linking.related_links_modal_error_title': 'Nous ne parvenons pas à charger les liens associés',
  'fabric.linking.related_links_modal_title': 'Liens associés',
  'fabric.linking.related_links_modal_unavailable_description':
    "Nous vérifions et ajoutons en permanence des liens associés pour les pages mises à jour ou d'autres types de contenu",
  'fabric.linking.related_links_modal_unavailable_title': "Nous n'avons trouvé aucun lien associé",
  'fabric.linking.related_links_not_found': "Nous n'avons trouvé aucun lien à afficher ici.",
  'fabric.linking.related_links_view_related_links': 'Voir les liens associés',
  'fabric.linking.related_links_view_related_urls': 'Afficher les liens récents',
  'fabric.linking.request_access': "Demander l'accès",
  'fabric.linking.request_access_description':
    "Votre équipe utilise {product} pour collaborer. Envoyez une demande d'accès à votre administrateur.",
  'fabric.linking.request_access_pending': 'Approbation en attente',
  'fabric.linking.request_access_pending_description':
    "Votre demande d'accès à {hostname} attend l'approbation de l'administrateur.",
  'fabric.linking.request_access_pending_title': "L'accès à {product} est en attente",
  'fabric.linking.request_access_to_view': 'Demandez un accès à {context} pour consulter ce ticket',
  'fabric.linking.request_access_to_view-issue-term-refresh': 'Demandez un accès à {context} pour consulter ce ticket',
  'fabric.linking.request_denied': "Votre demande d'accès a été refusée",
  'fabric.linking.request_denied_description':
    "Votre administrateur n'a pas approuvé votre demande de consultation des pages {product} depuis {hostname}.",
  'fabric.linking.restricted_link': 'Lien restreint, essayez un autre compte',
  'fabric.linking.retry': 'Réessayer',
  'fabric.linking.save': 'Enregistrer',
  'fabric.linking.sent_on_absolute': 'Envoyée le {context}',
  'fabric.linking.sent_on_relative': 'Envoyée {context}',
  'fabric.linking.srclink': 'Afficher dans',
  'fabric.linking.srclinkunknown': "Afficher l'original",
  'fabric.linking.status_change_load_error': 'Impossible de charger les états et les transitions',
  'fabric.linking.status_change_permission_error': "Vous n'avez pas l'autorisation de transitionner ce ticket.",
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    "Vous n'avez pas l'autorisation de transitionner ce ticket.",
  'fabric.linking.status_change_update_error': "Impossible de mettre à jour l'état",
  'fabric.linking.team_members_count': '{context} membres',
  'fabric.linking.try_again': 'Réessayez',
  'fabric.linking.try_another_account': 'Essayez un autre compte',
  'fabric.linking.unassigned': 'Non assigné',
  'fabric.linking.unauthorised_account_description':
    "Vous essayez de prévisualiser un lien vers une page {context} privée. Nous vous recommandons d'examiner l'URL ou de contacter le propriétaire de la page.",
  'fabric.linking.unauthorised_account_description_no_provider':
    "Vous essayez de prévisualiser un lien vers une page privée. Nous vous recommandons d'examiner l'URL ou de contacter le propriétaire de la page.",
  'fabric.linking.unauthorised_account_name': "Impossible d'afficher les pages privées de {context}",
  'fabric.linking.unauthorised_account_name_no_provider': "Impossible d'afficher les pages privées",
  'fabric.linking.unfollow': 'Ne plus suivre',
  'fabric.linking.unfollow_goal': "Ne plus suivre l'objectif",
  'fabric.linking.unfollow_goal_description':
    'Arrêtez de suivre cet objectif pour ne plus recevoir de notifications à son sujet',
  'fabric.linking.unfollow_goal_error':
    "Nous avons rencontré une erreur lors de la tentative d'annulation du suivi de l'objectif. Vérifiez votre connexion ou actualisez la page, puis réessayez.",
  'fabric.linking.unfollow_project': 'Ne plus suivre le projet',
  'fabric.linking.unfollow_project-galaxia': "Ne plus suivre l'espace",
  'fabric.linking.unfollow_project_description':
    'Arrêtez de suivre ce projet pour ne plus recevoir de notifications à son sujet',
  'fabric.linking.unfollow_project_description-galaxia':
    'Arrêtez de suivre cet espace pour ne plus recevoir de notifications à son sujet',
  'fabric.linking.unfollow_project_error':
    "Nous avons rencontré une erreur lors de la tentative d'annulation du suivi du projet. Vérifiez votre connexion ou actualisez la page, puis réessayez.",
  'fabric.linking.unfollow_project_error-galaxia':
    "Nous avons rencontré une erreur lors de la tentative d'annulation du suivi de l'espace. Vérifiez votre connexion ou actualisez la page, puis réessayez.",
  'fabric.linking.unlink_account': 'Dissocier le compte',
  'fabric.linking.updated_by': 'Modification par {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Afficher',
};
